export default __webpack_public_path__ + "static/media/culture_EP16.22b1b39a.png";